import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig";
import { doc, updateDoc, getDoc, setDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ProgressBar from "../components/ProgressBar"; // 追加
import "../styles/CompleteProfile.css";

const CompleteProfile1= () => {
  const [user] = useAuthState(auth);
  const [profile, setProfile] = useState({
    name: "",
    birthdayYear: "",
    birthdayMonth: "",
    birthdayDay: "",
    sex: "",
    location: "",
    major: "",
  });
  const [error, setError] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const navigate = useNavigate();

  const partnerSexOptions = [
    { value: '男性', label: '男性' },
    { value: '女性', label: '女性' },
    { value: 'トランス男性(FtM)', label: 'トランス男性(FtM)' },
    { value: 'トランス女性(MtF)', label: 'トランス女性(MtF)' },
    { value: 'ノンバイナリー', label: 'ノンバイナリー' },
    { value: 'その他', label: 'その他' }
  ];
  

  const purposeOptions = [
    { value: '友人', label: '友人' },
    { value: '恋人', label: '恋人' },
    { value: '結婚相手', label: '結婚相手' },
    { value: 'パートナー', label: 'パートナー' },
    { value: 'その他', label: 'その他' }
  ];

  const yearOptions = Array.from({ length: 100 }, (_, i) => ({ value: 2005 - i, label: `${2005 - i}` }));
  const monthOptions = Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }));
  const dayOptions = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }));


  const locationOptions = [
    { value: '北海道', label: '北海道' },
    { value: '青森', label: '青森' },
    { value: '岩手', label: '岩手' },
    { value: '宮城', label: '宮城' },
    { value: '秋田', label: '秋田' },
    { value: '山形', label: '山形' },
    { value: '福島', label: '福島' },
    { value: '茨城', label: '茨城' },
    { value: '栃木', label: '栃木' },
    { value: '群馬', label: '群馬' },
    { value: '埼玉', label: '埼玉' },
    { value: '千葉', label: '千葉' },
    { value: '東京', label: '東京' },
    { value: '神奈川', label: '神奈川' },
    { value: '新潟', label: '新潟' },
    { value: '富山', label: '富山' },
    { value: '石川', label: '石川' },
    { value: '福井', label: '福井' },
    { value: '山梨', label: '山梨' },
    { value: '長野', label: '長野' },
    { value: '岐阜', label: '岐阜' },
    { value: '静岡', label: '静岡' },
    { value: '愛知', label: '愛知' },
    { value: '三重', label: '三重' },
    { value: '滋賀', label: '滋賀' },
    { value: '京都', label: '京都' },
    { value: '大阪', label: '大阪' },
    { value: '兵庫', label: '兵庫' },
    { value: '奈良', label: '奈良' },
    { value: '和歌山', label: '和歌山' },
    { value: '鳥取', label: '鳥取' },
    { value: '島根', label: '島根' },
    { value: '岡山', label: '岡山' },
    { value: '広島', label: '広島' },
    { value: '山口', label: '山口' },
    { value: '徳島', label: '徳島' },
    { value: '香川', label: '香川' },
    { value: '愛媛', label: '愛媛' },
    { value: '高知', label: '高知' },
    { value: '福岡', label: '福岡' },
    { value: '佐賀', label: '佐賀' },
    { value: '長崎', label: '長崎' },
    { value: '熊本', label: '熊本' },
    { value: '大分', label: '大分' },
    { value: '宮崎', label: '宮崎' },
    { value: '鹿児島', label: '鹿児島' },
    { value: '沖縄', label: '沖縄' },
    { value: 'その他', label: 'その他' },
];


  const sexualOrientationOptions = [
    { value: 'ストレート', label: 'ストレート' },
    { value: 'ゲイ', label: 'ゲイ' },
    { value: 'レズビアン', label: 'レズビアン' },
    { value: 'バイセクシュアル', label: 'バイセクシュアル' },
    { value: 'パンセクシュアル', label: 'パンセクシュアル' },
    { value: 'その他', label: 'その他' },
  ];
  const spectrumOptions = [
    { value: 'アセクシュアル', label: 'アセクシュアル' },
    { value: 'グレイセクシュアル', label: 'グレイセクシュアル' },
    { value: 'デミセクシュアル', label: 'デミセクシュアル' },
    { value: 'リスセクシュアル', label: 'リスセクシュアル' },
    { value: 'ノンセクシュアル', label: 'ノンセクシュアル' },
    { value: 'その他', label: 'その他' },
  ];


  useEffect(() => {
    if (user) {
      user.reload().then(() => {
        setEmailVerified(user.emailVerified);
      });

      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "members", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            
            let birthdayYear = "";
            let birthdayMonth = "";
            let birthdayDay = "";
      
            if (data.birthday) {
              const birthdayDate = new Date(data.birthday);
              birthdayYear = birthdayDate.getFullYear();
              birthdayMonth = birthdayDate.getMonth() + 1; // JavaScriptの月は0始まりのため+1
              birthdayDay = birthdayDate.getDate();
            }
      
            setProfile({
              name: data.name || "",
              birthdayYear,  // ISO形式から年を取得
              birthdayMonth, // ISO形式から月を取得
              birthdayDay,   // ISO形式から日を取得
              sex: data.sex || "",
              location: data.location || "",
              spectrum: data.spectrum || "",
              sexualOrientation: data.sexualOrientation || "",
              aim: data.aim || [],
              partner_sex: data.partner_sex || [], // ← 追加
            });            
          }
        } catch (error) {
          console.error("Error fetching profile:", error.message);
          setError("プロフィールの取得中にエラーが発生しました。");
        }
      };
      
      fetchProfile();
    }
  }, [user]);

  const handleSave = async () => {
    if (!emailVerified) {
      setError("メールアドレスの認証が完了していません。メールを確認してください。");
      return;
    }
  
    const { name, birthdayYear, birthdayMonth, birthdayDay, sex, location, spectrum, sexualOrientation, aim } = profile;
  
    if (name && birthdayYear && birthdayMonth && birthdayDay && sex && location) {
      try {
        const userDocRef = doc(db, "members", user.uid);
        const docSnap = await getDoc(userDocRef);
  
        const birthday = new Date(birthdayYear, birthdayMonth - 1, birthdayDay).toISOString(); // ISO形式に変換
  
        const profileData = {
          name,
          birthday,  // ISO形式で保存
          sex,
          location,
          spectrum: spectrum || "",
          sexualOrientation: sexualOrientation || "",
          aim: aim || [],
          partner_sex: profile.partner_sex || [], // ← 追加
        };
  
        if (docSnap.exists()) {
          await updateDoc(userDocRef, profileData);
        } else {
          await setDoc(userDocRef, profileData);
        }
  
        navigate("/complete-profile2"); // 次のページへ
      } catch (error) {
        console.error("Error saving profile:", error.message);
        setError("プロフィールの保存中にエラーが発生しました。");
      }
    } else {
      setError("すべての必須項目を入力してください。");
    }
  };
  
  

  return (
    <div className="complete-profile-container">
      <ProgressBar step={1} totalSteps={6} /> {/* 進捗バーを追加 */}

      <h2>基本プロフィールを入力(必須)</h2>
      {error && <p className="error-message">{error}</p>}

      {emailVerified ? (
        <>

        
          <label>お名前（7文字まで）:</label>
          <div className="block-label">
          <input
            type="text"
            name="name"
            value={profile.name}
            onChange={(e) => setProfile({ ...profile, name: e.target.value })}
            placeholder="お名前（７文字まで）"
            className="profile-input"
            required
          />      </div>

<br></br>

<div className="block-label-x">
          <label>生年月日:</label>
          <div className="birthday-container">
            <Select name="birthdayYear" isSearchable={false}  value={{ value: profile.birthdayYear, label: profile.birthdayYear }} onChange={(option) => setProfile({ ...profile, birthdayYear: option.value })} options={[{ value: "", label: "年" }, ...Array.from({ length: 100 }, (_, i) => ({ value: 2005 - i, label: `${2005 - i}` }))]} className="birthday-select" />
            <Select name="birthdayMonth" isSearchable={false}  value={{ value: profile.birthdayMonth, label: profile.birthdayMonth }} onChange={(option) => setProfile({ ...profile, birthdayMonth: option.value })} options={[{ value: "", label: "月" }, ...Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }))]} className="birthday-select" />
            <Select name="birthdayDay" isSearchable={false}  value={{ value: profile.birthdayDay, label: profile.birthdayDay }} onChange={(option) => setProfile({ ...profile, birthdayDay: option.value })} options={[{ value: "", label: "日" }, ...Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }))]} className="birthday-select" />
            </div></div>

            <div className="form-group-a">
  <label>性別:</label>
  <Select
    name="sex"
    isSearchable={false}
    value={profile.sex ? { value: profile.sex, label: profile.sex } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, sex: option.value })}
    options={[
      { value: "", label: "選択してください" },
      { value: "男性", label: "男性" },
      { value: "女性", label: "女性" },
      { value: "トランス男性(FtM)", label: "トランス男性(FtM)" },
      { value: "トランス女性(MtF)", label: "トランス女性(MtF)" },
      { value: "ノンバイナリー", label: "ノンバイナリー" },
      { value: "その他", label: "その他" },
    ]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>居住地:</label>
  <Select
    name="location"
    isSearchable={false}
    value={profile.location ? { value: profile.location, label: profile.location } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, location: option.value })}
    options={[{ value: "", label: "選択してください" }, ...locationOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>Aceスペクトラム:</label>
  <Select
    name="spectrum"
    isSearchable={false}
    value={profile.spectrum ? { value: profile.spectrum, label: profile.spectrum } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, spectrum: option.value })}
    options={[{ value: "", label: "選択してください" }, ...spectrumOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>性的指向:</label>
  <Select
    name="sexualOrientation"
    isSearchable={false}
    value={profile.sexualOrientation ? { value: profile.sexualOrientation, label: profile.sexualOrientation } : { value: "", label: "選択してください" }}
    onChange={(option) => setProfile({ ...profile, sexualOrientation: option.value })}
    options={[{ value: "", label: "選択してください" }, ...sexualOrientationOptions]}
    className="select-box"
  />
</div>

<div className="form-group-a">
  <label>求める相手<br></br>(複数選択可):</label>
  <Select
    name="aim"
    isMulti
    isSearchable={false}
    value={profile.aim && profile.aim.length > 0 ? purposeOptions.filter(option => profile.aim.includes(option.value)) : []}
    onChange={(selectedOptions) =>
      setProfile({ ...profile, aim: selectedOptions.map(option => option.value) })
    }
    options={purposeOptions}
    className="select-box"
    placeholder="選択してください"
    noOptionsMessage={() => "選択肢がありません"}
  />
</div>

<div className="form-group-a">
  <label>お相手に求める性別<br />(複数選択可):</label>
  <Select
    name="partner_sex"
    isMulti
    isSearchable={false}
    value={
      profile.partner_sex && profile.partner_sex.length > 0
        ? partnerSexOptions.filter(option => profile.partner_sex.includes(option.value))
        : []
    }
    onChange={(selectedOptions) =>
      setProfile({ ...profile, partner_sex: selectedOptions.map(option => option.value) })
    }
    options={partnerSexOptions}
    className="select-box"
    placeholder="選択してください"
    noOptionsMessage={() => "選択肢がありません"}
  />
</div>





          <button onClick={handleSave} className="complete-profile-button">次へ</button>
        </>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default CompleteProfile1;
